import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { PageTransition } from '../components/PageTransition';
import { LiveDot, USSD_MENU } from '../components/UssdPanel';
import { useSiteChat } from '../contexts/ChatContext';
import Seo from '../components/Seo';

/**
 * A dead URL is a dropped session. USSD says so with `END`, so this page does too.
 */
function NotFound() {
  const navigate = useNavigate();
  const { openChat } = useSiteChat();

  return (
    <>
      <Seo
        title="404 | Dennis M. Nyabuti"
        description="This page does not exist."
        path="/404"
        noindex
      />

      <PageTransition>
        <div className="shell grid items-start gap-12 py-20 sm:py-28 lg:grid-cols-[minmax(0,1.15fr)_minmax(19rem,0.85fr)] lg:gap-16">
          <div>
            <p className="label">Error 404</p>
            <h1 className="mt-6 text-display">
              Session
              <br />
              <em className="italic text-signal">ended.</em>
            </h1>
            <p className="mt-8 max-w-md text-deck text-muted-foreground">
              There is nothing at this address. Dial again from the menu, or start over
              at the beginning.
            </p>
            <Link to="/" className="link-rule mt-8 inline-block text-sm">
              Back to the home page
            </Link>
          </div>

          <div className="bg-panel text-panel-foreground font-mono text-sm p-6 sm:p-8 rounded-sm border border-black/40 dark:border-white/10">
            <p className="text-panel-muted text-eyebrow uppercase tracking-[0.18em]">USSD session</p>
            <p className="mt-5">
              <span className="text-panel-alert">END</span>{'  '}Invalid choice.
            </p>
            <ul className="mt-6 space-y-1">
              {USSD_MENU.map((item) => (
                <li key={item.key}>
                  <button
                    type="button"
                    onClick={() => (item.chat ? openChat() : navigate(item.to))}
                    className="flex w-[calc(100%+1rem)] items-baseline gap-3 -mx-2 rounded-sm px-2 py-1 text-left transition-colors hover:bg-white/[0.07]"
                  >
                    <span className="tabular-nums text-panel-signal">{item.key}.</span>
                    <span className={item.chat ? 'text-panel-signal' : undefined}>{item.label}</span>
                    {item.live && <LiveDot className="ml-1.5 self-center" />}
                  </button>
                </li>
              ))}
            </ul>
            <p className="mt-6 border-t border-white/10 pt-4 text-panel-muted text-xs">
              Reply with a number
              <span className="ml-1 inline-block text-panel-signal animate-caret" aria-hidden="true">_</span>
            </p>
          </div>
        </div>
      </PageTransition>
    </>
  );
}

export default NotFound;
